import axios from "~/plugins/axios";

export default {
  paginateEmailTemplates(page, perPage, includes = []) {
    return axios.get("/web_api/v1/template/email", {
      params: {
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  getTemplateById(templateId, includes = []) {
    return axios.get(`/web_api/v1/template/${templateId}`, {
      params: {
        includes,
      },
    }).then((response) => response.data);
  },
  getParsedTemplateByIdAndInstances(templateId, instances) {
    return axios.post(`/web_api/v1/template/${templateId}/parsed_template_for_instance`, {
      instances,
    }).then((response) => response.data);
  },
  updateTemplate(template) {
    return axios.put(`/web_api/v1/template/${template.id}`, template).then((response) => response.data);
  },
  storeTemplate(template) {
    return axios.post("/web_api/v1/template", template).then((response) => response.data);
  },
};
